var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFocus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 3.64752C18.1649 3.64752 22.3525 7.835 22.3525 13.0001C22.3525 18.1652 18.1651 22.3527 13 22.3527C7.83488 22.3527 3.6474 18.1652 3.6474 13.0001C3.6474 7.835 7.83488 3.64752 13 3.64752V3.64752ZM0.000118894 0H7.91685V2.57088H2.57088V7.91685H0L0.000118894 0ZM2.571 18.083V23.4289H7.91697V25.9998H0.000237788V18.0831L2.571 18.083ZM18.0833 0H26V7.91673H23.4291V2.57077H18.0832L18.0833 0ZM26 18.083V25.9997H18.0833V23.4288H23.4292V18.0829L26 18.083ZM13.3808 7.49323C16.1269 7.68027 18.3197 9.87337 18.507 12.6194H20.1845C19.9931 8.94935 17.0509 6.00708 13.3806 5.81555L13.3808 7.49323ZM20.1847 13.3805H18.5072C18.3206 16.1263 16.1266 18.3194 13.381 18.5067V20.1842C17.0511 19.9928 19.9933 17.0506 20.1849 13.3803L20.1847 13.3805ZM12.6201 20.1844V18.5069C9.8745 18.3203 7.68071 16.1263 7.49389 13.3807H5.81639C6.00784 17.0508 8.95001 19.993 12.6203 20.1846L12.6201 20.1844ZM5.81621 12.6198H7.49371C7.68097 9.8742 9.87408 7.68042 12.6199 7.49359V5.81609C8.94983 6.00754 6.00755 8.94971 5.81603 12.62L5.81621 12.6198Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFocus);
export default __webpack_public_path__ + "static/media/icon_focus.dda633ba4fea065b4d4c71a796e7df99.svg";
export { ForwardRef as ReactComponent };